import { appSettings } from "@/app.settings";
import userStore from "@/store/index.js"
import { UserManager, WebStorageStateStore } from "oidc-client-ts";

const settings = {
  authority: appSettings.authority,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  client_id: appSettings.clientId,
  redirect_uri: appSettings.callbackUrl,
  response_type: "code",
  scope: appSettings.verifyPermissions ? "openid profile email permissions" : "openid profile email",
  filterProtocolClaims: true,
  metadata: {
    issuer: appSettings.issuer,
    authorization_endpoint: appSettings.authority + "/oauth2/authorize",
    userinfo_endpoint: appSettings.authority + "/oauth2/userinfo",
    token_endpoint: appSettings.authority + "/oauth2/token",
    end_session_endpoint: appSettings.authority + "/oauth2/end_session",
    jwks_uri: appSettings.authority + "/oauth2/public_keys"
  }
};

const userManager = new UserManager(settings);

userManager.events.addUserLoaded((user) => {
  userStore.dispatch("setUser", user);
});

export { userManager };
